export enum FeatureFlagAudience {
    PARTNER = 'PARTNER',
    ENTREPRENEUR = 'ENTREPRENEUR',
    GENERAL = 'GENERAL',
}

export interface FeatureFlag {
    name: string;
    value: boolean;
}

export interface FeatureFlagGroup {
    audience: FeatureFlagAudience;
    label: string;
    flags: FeatureFlag[];
}

const AUDIENCE_LABELS: Record<FeatureFlagAudience, string> = {
    [FeatureFlagAudience.PARTNER]: 'Partner',
    [FeatureFlagAudience.ENTREPRENEUR]: 'Entrepreneur',
    [FeatureFlagAudience.GENERAL]: 'General',
};

const AUDIENCE_ORDER: FeatureFlagAudience[] = [
    FeatureFlagAudience.PARTNER,
    FeatureFlagAudience.ENTREPRENEUR,
    FeatureFlagAudience.GENERAL,
];

export function getFeatureFlagAudience(flagName: string): FeatureFlagAudience {
    if (flagName.startsWith('PARTNER_'))
        return FeatureFlagAudience.PARTNER;

    if (flagName.startsWith('ENTREPRENEUR_'))
        return FeatureFlagAudience.ENTREPRENEUR;

    return FeatureFlagAudience.GENERAL;
}

export function groupFlagsByAudience(flags: FeatureFlag[]): FeatureFlagGroup[] {
    return AUDIENCE_ORDER
        .map((audience) => ({
            audience,
            label: AUDIENCE_LABELS[audience],
            flags: flags
                .filter((flag) => getFeatureFlagAudience(flag.name) === audience)
                .sort((a, b) => a.name.localeCompare(b.name)),
        }))
        .filter((group) => group.flags.length > 0);
}
